// HomeMetricGenerator.js

import React from 'react';
import InteractiveBarChart from '../BarChart'; // Adjust import path as necessary
import { Link } from 'react-router-dom';
import './home_metric.css';

const HomeMetricGenerator = () => {
    return (
        <div className="metric-home-container">
            <div className="metric-home-header">
                <h1>FramSys Metric Generator</h1>
            </div>

          
            <div className="metric-home-section">
                <div className="metric-home-text">
                    <h2>Real-Time Video Data Analysis</h2>
                    <p>Unlock valuable insights from real-time video data with our advanced tools. Use our indoor hardware or upload your own data to get tailored metrics for your business needs.</p>
                    <div>
                        <h3>Optimized for Better Decision-Making</h3>
                        <p>Enhance marketing strategies and gain better operational insights. Make informed decisions to drive growth.</p>
                    </div>
                    <div>
                        <h3>Easy Install & Maintenance</h3>
                        <p>We install the generator and handle maintenance, allowing you to focus on your business.</p>
                    </div>
                    <Link className="link" to="/metric-generator">Learn More</Link>
                </div>
                <div className="metric-home-image">
                    <img src={require('../../assets/misc/metric_car.png')} alt="Metric Car" />
                </div>
            </div>
            

            <div className="metric-home-section">
                <div className="metric-home-image">
                    <img src={require('../../assets/misc/metric_people.png')} alt="Metric People"  />
                </div>
                <div className="metric-home-text">
                    <h2>Visualize Your Data</h2>
                    <p>Get detailed visualizations that help you understand your data better. Make informed decisions with ease.</p>
                    <div>
                        <h3>Automatic Reports</h3>
                        <p>Automatically generated reports provide a comprehensive overview of your metrics and trends.</p>
                        <h3>Graphs, Heatmaps and Analysis</h3>
                        <p>Pre-made report templates so that patterns and trends are easily spotted</p>
                        <h3>Live, weekly or monthly reports</h3>
                        <p>Depending on your needs the metric generator provides reports customized for your needs.</p>

                      
                    </div>
                </div>
            </div>

       
            <div className="metric-home-section">
                <div className="metric-home-text">
                    <h2>Interactive Data Insights</h2>
                    <p>Explore your data with an interactive bar chart that allows you to dive deeper into specific metrics.</p>
                </div>

                <InteractiveBarChart />
            </div>

        </div>
    );
};

export default HomeMetricGenerator;